// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { useAppOptions } from '../../../context/AppContext';
import { Box, Container, Grid, MUILink, Typography } from '../../../lib/base';
import { InstagramIcon, XIcon, YouTubeIcon } from '../../../lib/icons';
import * as routes from '../../../routes';
import { BetterLinkUnderline } from './BetterLinkUnderline';
import { Copyright } from './Copyright';
import FacebookIcon from './FacebookIcon';

export function PublicFooter(): React.ReactElement {
  const appOptions = useAppOptions();

  return (
    <Box component="footer" sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', mt: 'auto', pt: 5, pb: 3 }}>
      <Container>
        <Grid container spacing={4} justifyContent="space-between" flexWrap="wrap">
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="h6" gutterBottom>
              Company
            </Typography>
            <BetterLinkUnderline to={routes.TEAM}>
              <Typography>About Us</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.PRICING}>
              <Typography>Pricing</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.FEEDBACK} external>
              <Typography>Feedback</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.CONTACT}>
              <Typography>Contact Us</Typography>
            </BetterLinkUnderline>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="h6" gutterBottom>
              Resources
            </Typography>
            <BetterLinkUnderline to={routes.BLOG}>
              <Typography>Blog</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.FEATURES}>
              <Typography>Features</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.TUTORIALS}>
              <Typography>Tutorials</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.DOCS}>
              <Typography>Documentation</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.COMPETITORS}>
              <Typography>Competitors</Typography>
            </BetterLinkUnderline>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="h6" gutterBottom>
              Free Tools
            </Typography>
            <BetterLinkUnderline to={routes.TRAY_CALCULATOR}>
              <Typography>Tray Calculator</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.PRICE_CALCULATOR}>
              <Typography>Price Calculator</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.SEED_DENSITY_CALCULATOR}>
              <Typography>Seed Density Calculator</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.EXCEL_TOOL}>
              <Typography>Excel Production Planner</Typography>
            </BetterLinkUnderline>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="h6" gutterBottom>
              Legal
            </Typography>
            <BetterLinkUnderline to={routes.PRIVACY}>
              <Typography>Privacy Policy</Typography>
            </BetterLinkUnderline>
            <BetterLinkUnderline to={routes.TERMS}>
              <Typography>Terms of Service</Typography>
            </BetterLinkUnderline>
            <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
              <MUILink href={appOptions.meta.social.fb} color="inherit" target="_blank" aria-label="Facebook">
                <FacebookIcon />
              </MUILink>
              <MUILink href={appOptions.meta.social.instagram} color="inherit" target="_blank" aria-label="Instagram">
                <InstagramIcon />
              </MUILink>
              <MUILink href={appOptions.meta.social.twitter} color="inherit" target="_blank" aria-label="X / Twitter">
                <XIcon />
              </MUILink>
              <MUILink href={appOptions.meta.social.youtube} color="inherit" target="_blank" aria-label="YouTube">
                <YouTubeIcon />
              </MUILink>
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ borderTop: 1, borderColor: 'grey.400', mt: 4, pt: 2, textAlign: 'center' }}>
          <Copyright />
        </Box>
      </Container>
    </Box>
  );
}
